// extracted by mini-css-extract-plugin
export var banner = "_oi-0";
export var settingRow = "_oi-2";
export var titleIcon = "_oi-1";